import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import { Option } from '../../../models/option.model';

@Component({
  selector: 'mom-form-field-checkbox-list',
  templateUrl: './form-field-checkbox-list.component.html',
  styleUrls: ['./form-field-checkbox-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormFieldCheckboxListComponent implements OnChanges {
  @Input() id: string;
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() options: Option<unknown>[];

  currentSelected: unknown[] = [];
  faInfoCircle = faInfoCircle;

  private exclusiveOptionValues: unknown[] = [];

  ngOnChanges(): void {
    this.currentSelected = this.formCtrl.value ?? [];
    this.exclusiveOptionValues = this.options.filter((option) => option.exclusive).map((option) => option.value);

    if (this.currentSelected.length > 0) {
      this.scrollToFirstSelectedOption();
    }
  }

  mapChecked(optionChecked: Option<unknown>): void {
    const index = this.currentSelected.findIndex((opt) => opt === optionChecked.value);

    if (index > -1) {
      this.currentSelected.splice(index, 1);
    } else {
      this.clearExclusiveOptions();
      if (optionChecked.exclusive) {
        this.currentSelected = [];
      }
      this.currentSelected.push(optionChecked.value);
    }

    this.formCtrl.patchValue(this.currentSelected);
  }

  private scrollToFirstSelectedOption(): void {
    setTimeout(() => {
      document.getElementById(`${this.id}-${this.currentSelected[0]}`).scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  private clearExclusiveOptions(): void {
    this.exclusiveOptionValues.forEach((value) => {
      const index = this.currentSelected.findIndex((opt) => opt === value);
      if (index > -1) {
        this.currentSelected.splice(index, 1);
      }
    });
  }
}
